export default {
    ugcReports: {
        fetchFailed: 'Failed to load report list',
        empty: 'No reports yet',
        none: 'None',
        viewDetail: 'View detail',
        reasonSummaryItem: '{label} ×{count}',
        reportCount: '{count} reports',
        reportCountCollapse: 'Collapse ({count})',
        logsEmpty: 'No report logs',
        page: {
            contentTitle: 'Content reports',
            contentDesc: 'Aggregated reports by work or drama IP; expand rows for detail logs',
            userTitle: 'User reports',
            userDesc: 'Aggregated by reported user UID; click count to expand all details',
            commentTitle: 'Comment reports',
            commentDesc: 'Aggregated by comment ID for retention and search',
        },
        tabs: {
            work: 'Work reports',
            drama: 'Drama IP reports',
        },
        timePreset: {
            LAST_7_DAYS: 'Last 7 days',
            LAST_30_DAYS: 'Last 30 days',
            CUSTOM: 'Custom',
        },
        workKind: {
            SHORT_VIDEO: 'Short video',
            DRAMA_EPISODE: 'Drama episode',
        },
        search: {
            reportTime: 'Report time',
            customTime: 'Custom range',
            startDate: 'Start date',
            endDate: 'End date',
            reportType: 'Report reason',
            workKind: 'Work type',
            workId: 'Work ID',
            workName: 'Work name',
            dramaId: 'Drama ID',
            dramaName: 'Drama name',
            authorId: 'Author ID',
            authorName: 'Author nickname',
            reporterId: 'Reporter ID',
            reporterNickname: 'Reporter nickname',
            reportedUserId: 'Reported user ID',
            reportedUserNickname: 'Reported user nickname',
            commentId: 'Comment ID',
            commentUserId: 'Comment user ID',
            commentUserNickname: 'Comment user nickname',
            belongingWorkId: 'Work ID',
            belongingWorkName: 'Work name',
        },
        columns: {
            workId: 'Work ID',
            workInfo: 'Work info',
            workKind: 'Work type',
            dramaId: 'Drama ID',
            dramaInfo: 'Drama info',
            dramaInfoIp: 'Drama info (IP)',
            episodeNo: 'Episode {no}',
            episodeCount: 'Episodes',
            totalEpisodes: '{count} episodes',
            author: 'Author',
            producerAuthor: 'Producer / Author',
            reasonSummary: 'Reason summary',
            reportTimeRange: 'First / Latest report',
            firstLabel: 'First: ',
            latestLabel: 'Latest: ',
            reportCount: 'Total reports',
            dramaReportCount: 'Drama total reports',
            action: 'Action',
            reportedUserAccount: 'Reported user',
            uidLabel: 'UID',
            commentId: 'Comment ID',
            commentContent: 'Comment content',
            commentAuthor: 'Comment author',
            belongingWork: 'Related work',
            belongingWorkWithEpisode: '{title} Ep. {no}',
            workIdLabel: 'Work ID:',
        },
        logs: {
            summary: '{count} report logs',
            userSummary: '{count} reports for user (UID: {uid})',
            syncTip: 'Data syncs in real time',
            reporter: 'Reporter',
            reporterFallback: 'Reporter',
            reporterId: 'Reporter ID',
            reason: 'Reason',
            reasonDetail: 'Details',
            reasonWithDesc: 'Reason: {reason} - "{desc}"',
            description: 'Description',
            submittedAt: 'Submitted at',
        },
        contentType: {
            vulgar_content: 'Vulgar content',
            illegal_activity: 'Illegal activity',
            sensitive_content: 'Sensitive content',
            gang_gambling: 'Gambling',
            harm_minors: 'Harm to minors',
            infringement: 'Infringement',
            quality_issue: 'Quality issue',
            other: 'Other',
            dislike: 'Dislike',
            unknown: 'Unknown',
        },
        userType: {
            inappropriate_profile: 'Inappropriate profile',
            impersonation: 'Impersonation',
            cyberbullying: 'Cyberbullying',
            pornographic_content: 'Pornographic content',
            suspected_fraud: 'Suspected fraud',
            safety_threat: 'Safety threat',
            ip_infringement: 'IP infringement',
            profile_violation: 'Profile violation',
            cyber_violence: 'Cyber violence',
            fraud: 'Fraud',
            personal_safety: 'Personal safety',
            infringement: 'Infringement',
            other: 'Other',
            unknown: 'Unknown',
        },
    },
};
